import React, { Component } from 'react';
import { getIcon } from '../../../Common/Common';
import { pushCommand, isEmpty, addAnimation } from '../../../Common/Common';

import Power_On_Off from './Components/Power_On_Off';
import Av_Slider from './Components/Av_Slider';
import Off_Timer from './Components/Off_Timer';
import Advanced_Settings from './Components/Advanced_Settings';

export default class LevelSwOperation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			on_off: this.props.point_info.stat != null ? this.props.point_info.stat : 'off',
		}
	}

	handleOnOff = () => {
		let val = 'off';
		let elem = document.getElementById('icon_container');

		if (this.state.on_off == 'off') {
			val = 'on';
			addAnimation(elem, 'fadeInLong', () => { }, 2000)
			this.setState({ on_off: 'on' });
		} else {
			addAnimation(elem, 'fadeOutLongFast', () => {
				this.setState({ on_off: 'off' });
			}, 200)
		}
		let command = 'stat';
		pushCommand(command, val, this.props.point_id);
	}

	handleChangeAV = (val) => {
		let command = 'av';
		pushCommand(command, val, this.props.point_id);
	}

	handleToggleOffTimer = (val) => {
		let command = 'off_timer';
		pushCommand(command, val, this.props.point_id);
	}

	render() {
		let icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);
		let icon_width = 50;
		let power_icon_width = 150;

		let op_button_cell_style = {
			width: 80,
			height: 80,
			margin: 5,
			padding: 10,
			backgroundColor: 'white',
			borderRadius: 20,
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
			fontSize: 11,
		}

		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';
		let icon_container_style = {
			width: icon_width + 30,
			height: icon_width + 30,
			position: 'absolute',
			top: -(power_icon_width + 10),
			left: 20,
			backgroundImage: background_gradient,
			display: this.state.on_off == 'on' ? 'block' : 'none',
		}

		return (
			<div id='levelsw_operation' >
				<div style={{ cursor: 'pointer', }} onClick={this.handleOnOff}>
					<div style={{ verticalAlign: 'top', marginTop: 20 }}>
						<Power_On_Off
							style={{}}
							img_width={power_icon_width}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							on_off={this.state.on_off}
						/>
					</div>
					<div style={{ position: 'relative' }}>
						<div id='icon_container' style={icon_container_style}></div>
						<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width, opacity: 0.6, position: 'absolute', top: -(power_icon_width - 5), left: 35, }} />
					</div>
				</div>
				<div style={{ marginBottom: 20 }}>
					<Av_Slider
						point_id={this.props.point_id}
						width={this.props.width}
						point_info={this.props.point_info}
						receiver={this.props.receiver}
						handleChangeVal={this.handleChangeAV}
					/>
				</div>
				<div id='op_buttons' style={{ marginBottom: 10, }}>
					<div style={{ display: this.props.receiver.active_controller.user_class == 'Admin' ? 'inline-block' : 'none', verticalAlign: 'top' }}>
						<Off_Timer
							style={op_button_cell_style}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleOffTimer={this.handleToggleOffTimer}
						/>
					</div>
				</div>
				<Advanced_Settings
					point_id={this.props.point_id}
					point_info={this.props.point_info}
					receiver={this.props.receiver}
					width={this.props.width}
					height={this.props.height}
					colours={this.props.colours}
				/>
			</div>
		)
	}
}